<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="4" fill="#0D87EF"/>
    <path d="M4.375 8.16487L6.92789 10.9375L12.625 4.75" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>
